import { UserPickerSelectView } from "./UserPickerSelectView";
import type { UserPickerSingleSelectProps } from "./types";
import { StopClickPropagation, runOrToast } from "./utils";

export const UserPickerSingleSelect = ({
  users,
  value,
  onSelect,
  clearLabel,
  addLabel,
  searchPlaceholder,
  emptyText,
  isEditable = true,
  isLoading = false,
}: UserPickerSingleSelectProps) => (
  <StopClickPropagation>
    <UserPickerSelectView
      candidates={users}
      value={value}
      addLabel={addLabel}
      searchPlaceholder={searchPlaceholder}
      emptyText={emptyText}
      isEditable={isEditable}
      isLoading={isLoading}
      clearLabel={clearLabel}
      onSelect={(userId) => runOrToast(() => onSelect(userId))}
    />
  </StopClickPropagation>
);
